// Client-side image resize helper for landing-page gallery uploads.
// Same technique used by AdminDashboard for foto_profil.
export function resizeImage(file, maxDim = 1000) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      const img = new Image();
      img.onerror = reject;
      img.onload = () => {
        const scale = Math.min(1, maxDim / Math.max(img.width, img.height));
        const w = Math.round(img.width * scale);
        const h = Math.round(img.height * scale);
        const canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, w, h);
        resolve(canvas.toDataURL("image/jpeg", 0.85));
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}

// Fallback (static) images kept for the landing components when the admin
// has not yet uploaded custom content. These match the original design.
export const FALLBACK = {
  tentang: {
    image1:
      "https://images.unsplash.com/photo-1638271676156-f40fbfda17f0?crop=entropy&cs=srgb&fm=jpg&q=85",
    image2:
      "https://images.pexels.com/photos/36232116/pexels-photo-36232116.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=600",
    description:
      "Rumah para penghafal, penjaga warisan langit — dibangun untuk menghidupkan hafalan setiap santri.",
  },
  fasilitas: [
    {
      name: "Masjid Pondok",
      desc: "Pusat ibadah dan halaqah tahfizh dengan kapasitas 600 jamaah.",
      image:
        "https://images.pexels.com/photos/36232116/pexels-photo-36232116.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
    },
    {
      name: "Asrama Santri",
      desc: "Hunian nyaman, terpisah ikhwan & akhwat, dengan pengasuh 24 jam.",
      image:
        "https://images.unsplash.com/photo-1618190405497-00f284b5dda5?crop=entropy&cs=srgb&fm=jpg&q=85",
    },
    {
      name: "Ruang Kelas",
      desc: "Kelas modern dengan whiteboard, AC, dan sirkulasi cahaya alami.",
      image:
        "https://images.unsplash.com/photo-1629273229664-11fabc0becc0?crop=entropy&cs=srgb&fm=jpg&q=85",
    },
    {
      name: "Perpustakaan",
      desc: "Koleksi kitab klasik dan kontemporer berbahasa Arab & Indonesia.",
      image:
        "https://images.unsplash.com/photo-1589995635011-078e0bb91d11?crop=entropy&cs=srgb&fm=jpg&q=85",
    },
    {
      name: "Sarana Olahraga",
      desc: "Lapangan terbuka, panahan, dan berenang untuk membentuk fisik tangguh.",
      image:
        "https://images.unsplash.com/photo-1575645513913-c002ea3b2e01?crop=entropy&cs=srgb&fm=jpg&q=85",
    },
  ],
  pengajar: [
    {
      jabatan: "Pembina Pondok",
      nama: "Ust. Zafar Sidiq, S.Pd",
      image:
        "https://images.unsplash.com/photo-1629273229664-11fabc0becc0?crop=entropy&cs=srgb&fm=jpg&q=85",
    },
    {
      jabatan: "Mudir Pondok",
      nama: "Ust. Hasan Al Mubarok Sidiq, S.Pd",
      image:
        "https://images.unsplash.com/photo-1618190405497-00f284b5dda5?crop=entropy&cs=srgb&fm=jpg&q=85",
    },
    {
      jabatan: "Kepala Tahfizh Ikhwan",
      nama: "Ust. Hanif Habibulloh, S.Pd",
      image:
        "https://images.unsplash.com/photo-1575645513913-c002ea3b2e01?crop=entropy&cs=srgb&fm=jpg&q=85",
    },
    {
      jabatan: "Kepala Tahfizh Akhwat",
      nama: "Ustzh. Siska Pautri SL, S.Ak",
      image:
        "https://images.unsplash.com/photo-1589995635011-078e0bb91d11?crop=entropy&cs=srgb&fm=jpg&q=85",
    },
  ],
  galeri: [
    { caption: "", image: "https://images.unsplash.com/photo-1638271676156-f40fbfda17f0?crop=entropy&cs=srgb&fm=jpg&q=85" },
    { caption: "", image: "https://images.unsplash.com/photo-1629273229664-11fabc0becc0?crop=entropy&cs=srgb&fm=jpg&q=85" },
    { caption: "", image: "https://images.unsplash.com/photo-1618190405497-00f284b5dda5?crop=entropy&cs=srgb&fm=jpg&q=85" },
    { caption: "", image: "https://images.unsplash.com/photo-1589995635011-078e0bb91d11?crop=entropy&cs=srgb&fm=jpg&q=85" },
    { caption: "", image: "https://images.pexels.com/photos/36232116/pexels-photo-36232116.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
    { caption: "", image: "https://images.unsplash.com/photo-1575645513913-c002ea3b2e01?crop=entropy&cs=srgb&fm=jpg&q=85" },
    { caption: "", image: "https://images.pexels.com/photos/34256958/pexels-photo-34256958.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
    { caption: "", image: "https://images.unsplash.com/photo-1550867571-6d0bc79eb6f1?crop=entropy&cs=srgb&fm=jpg&q=85" },
  ],
  pendaftaran: {
    image:
      "https://customer-assets.emergentagent.com/job_generasi-flow/artifacts/44yusekn_WhatsApp%20Image%202026-05-06%20at%2011.54.42.jpeg",
  },
  iklan: [
    { image: "", link: "" },
    { image: "", link: "" },
    { image: "", link: "" },
    { image: "", link: "" },
    { image: "", link: "" },
  ],
};

// Helper: pick uploaded image or fallback.
export function pick(uploaded, fallback) {
  return uploaded && String(uploaded).trim().length > 0 ? uploaded : fallback;
}
